import { JsonObject, JsonProperty } from 'json2typescript';
import { SafeUrl } from '@angular/platform-browser';

import { MediaContext } from './media-context.enum';
import { MediaType } from './media-type.enum';

/**
 * åªä½èµæº(å¾ç, é³é¢, è§é¢)ä¿¡æ¯
 */
@JsonObject
export class Media {
  /**
   * åªä½èµæºçé®å¼, ç¨äºæ ç¤ºåªä½èµæºå¨ossä¸­å­æ¾çä½ç½®
   * ä¾å­:
   * /dev/video/dept1/abc.mp4
   * /dev/other/dept2/xyz.png
   */
  @JsonProperty('key', String)
  key: string = undefined;

  /**
   * è¯¥åªä½èµæºå·ä½çurlå°å
   * ä¸è¬ç¨keyå¼ååå°æ¥è¯¢è·å¾, ä½¿ç¨é¿éäºstsæ§å¶è®¿é®æé, ä¸è¬æ2å°æ¶è¿ææ¶é´
   * ä¾å­:
   * https://media.512ks.cn/dev/other/tenant764/1331d3db3c2f96b4f949ad6cf97a9d8e.jpg?Expires=1511254053&OSSAccessKeyId=LTAIoGU8SUvxZrCy&
   * Signature=V83jY722mWnfBhX2xD8x%2Bbqxn6M%3D&x-oss-process=image%2Fformat%2Cjpg%2Fresize%2Ch_400%2Fquality%2CQ_75
   */
  @JsonProperty('url', String, true)
  url: string|SafeUrl = undefined;

  /**
   * è¯¥åªä½èµæºå·ä½çé¢è§urlå°å
   * ä¸è¬ç¨keyå¼ååå°æ¥è¯¢è·å¾, ä½¿ç¨é¿éäºstsæ§å¶è®¿é®æé, ä¸è¬æ2å°æ¶è¿ææ¶é´
   * ä¾å­:
   * https://media.512ks.cn/dev/other/tenant764/1331d3db3c2f96b4f949ad6cf97a9d8e.jpg?Expires=1511254053&OSSAccessKeyId=LTAIoGU8SUvxZrCy&
   * Signature=V83jY722mWnfBhX2xD8x%2Bbqxn6M%3D&x-oss-process=image%2Fformat%2Cjpg%2Fresize%2Ch_400%2Fquality%2CQ_75
   */
  @JsonProperty('previewUrl', String, true)
  previewUrl: string|SafeUrl = undefined;

  /**
   * æä»¶åªä½ä½¿ç¨ä¸ä¸æç¯å¢
   */
  @JsonProperty('context', String, true)
  context: MediaContext = MediaContext.SOURCE;

  /**
   * æä»¶å¤§å°
   */
  @JsonProperty('size', Number, true)
  size: number = undefined;

  /**
   * æä»¶ç±»å
   */
  @JsonProperty('type', String, true)
  type: MediaType = MediaType.DOCUMENT;

  /**
   * æä»¶
   */
  file: any;

  constructor(type?: MediaType, key?: string) {
    this.type = type;
    this.key = key;
  }
}
